<template>
  <v-card width="100%">
    <template>
      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        top
        color="deep-purple accent-4"
      ></v-progress-linear>
    </template>
    <v-card-title>
      Units
      <v-spacer></v-spacer>

      <div class="tableSearch mr10px">
        <v-text-field
          v-model="search"
          label="Search"
          prepend-inner-icon="mdi-magnify"
          single-line
          filled
          rounded
          dense
          hide-details
        ></v-text-field>
      </div>
    </v-card-title>
    <v-data-table :headers="headers" :items="arrItems" :search="search">
    <template v-slot:item.view="{ item }">
      <router-link :to="'/units/'+item.UnitID">View</router-link>
     </template>
    
      <template v-slot:item.address="{ item }">
       {{
          item.Address1
        }}
        {{
          item.Address2
        }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      search: "",
      headers: [
         {
          text: "View",
          align: "left",
          sortable: true,
          value: "view",
        },
        {
          text: "Lot#",
          align: "left",
          sortable: true,
          value: "LotNumber",
        },
        {
          text: "Unit#",
          align: "left",
          sortable: true,
          value: "UnitNumber",
        },{
          text: "Address",
          align: "left",
          sortable: true,
          value: "address",
        },{
          text: "City",
          align: "left",
          sortable: true,
          value: "City",
        },{
          text: "State",
          align: "left",
          sortable: true,
          value: "State",
        },{
          text: "Zip",
          align: "left",
          sortable: true,
          value: "ZipCode",
        }
        ,{
          text: "Vacant?",
          align: "left",
          sortable: true,
          value: "Vacant",
        }
        ,{
          text: "Active?",
          align: "left",
          sortable: true,
          value: "InActive",
        },
      ],
      loading: true,
      arrItems: [],
      model: {},
      dialog: false,
    };
  },
  async created() {
    this.refresh();
  },
  methods: {
    async refresh() {
      console.log("inside refersf");

      this.loading = true;
      this.arrItems = await api.getUnits();
      this.loading = false;
    },
    async populatePostToEdit(post) {
      this.model = Object.assign({}, post);
    },
    async savePost() {
      if (this.model.id) {
        await api.updatePost(this.model.id, this.model);
      } else {
        await api.createPost(this.model);
      }
      this.model = {}; // reset form
      await this.refresh();
    },
    async deletePost(id) {
      if (confirm("Are you sure you want to delete this post?")) {
        // if we are editing a post we deleted, remove it from the form
        if (this.model.id === id) {
          this.model = {};
        }
        await api.deletePost(id);
        await this.refresh();
      }
    },
  },
};
</script>
